// Angular imports
import { Component, EventEmitter, Input, Output } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// Model imports
import { PortfolioAssignmentsResultDto } from '../_models/portfolio-assignments-result-dto';

@Component({
    selector: 'app-portfolio-assignments',
    templateUrl: './portfolio-assignments.component.html',
    styleUrls: ['./portfolio-assignments.component.scss']
})
export class PortfolioAssignmentsComponent {
    @Input() visible: boolean;
    @Input() popUpTitle: string;
    @Input() portfolioAssignmentData: PortfolioAssignmentsResultDto[];
    @Output() portfolioAssignmentClose: EventEmitter<boolean> = new EventEmitter();

    iconCheck = IconConstants.CHECK;
    iconClose = IconConstants.CLOSE;

    onShown(e: any): void {
        e.component.repaint();
    }

    onHidden(): void {
        this.popUpTitle = '';
        this.portfolioAssignmentData = [];
        this.portfolioAssignmentClose.emit(false);
        this.visible = false;
    }
}
